/** @type {import('../schema').ProcessDefinition} */
const eliminacionEdificio = {
  id: "eliminacion-edificio",
  name: "Solicitud de eliminación de edificio",
  category: "edificios",
  outcome:
    "Eliminar un edificio y sus datos asociados, con aprobación del Super Admin y respaldo para auditoría.",
  trigger:
    "El Administrador solicita la eliminación desde Editar edificio.",
  actors: ["Administrador", "Super Admin", "Sistema"],
  status: "COMPLETO",
  description:
    "Solicitud del admin, aprobación del Super Admin con vista de impacto y borrado en cascada con respaldo en deleted_buildings.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sa", actor: "Super Admin" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Solicitud de eliminación",
      description:
        "El Administrador indica el motivo; la solicitud nace pendiente.",
      evidence: "src/screens/admin/SolicitudesEliminacion.jsx",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "notification",
      label: "Notificación al Super Admin",
      description:
        "Avisa al Super Admin con un badge en la barra lateral.",
    },
    {
      id: "s3",
      laneId: "sa",
      type: "task",
      label: "Revisión con impacto",
      description:
        "Ve las solicitudes pendientes y cuántas unidades/pagos/gastos se borrarán.",
    },
    {
      id: "s4",
      laneId: "sa",
      type: "decision",
      label: "¿Aprobar o rechazar?",
      description:
        "Solo el Super Admin aprueba la eliminación.",
    },
    {
      id: "s5",
      laneId: "sys",
      type: "task",
      label: "Borrado en cascada + respaldo",
      description:
        "En el servidor (approveBuildingDeletion): respalda conteos en deleted_buildings, limpia las invitaciones pendientes al edificio y borra en lotes: apartments, admin, userbuilding, employeebuilding, occupancies, expenses, incidents, payments, expensesapartments, montlyaccount, amenitycharges, amenity_signups, apartmentcharges, buildingincomes, criteriabuilding, permisos y el building. No borra users ni consent_log. Si falla un paso, la solicitud queda en error y se reintenta la aprobación.",
      evidence: "functions/identity/edificios.js:714 (procesarBaja)",
    },
    {
      id: "s6",
      laneId: "sys",
      type: "end",
      label: "Solicitud aprobada (edificio eliminado)",
      description:
        "Deja la solicitud aprobada con resultados y audita.",
    },
    {
      id: "s7",
      laneId: "sa",
      type: "end",
      label: "Solicitud rechazada",
      description:
        "El edificio sigue activo.",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5", label: "Aprobar" },
    { from: "s4", to: "s7", label: "Rechazar" },
    { from: "s5", to: "s6" },
  ],
};
export default eliminacionEdificio;
